import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Job} from '../model/index';

@Injectable()
export class JobService {
    constructor(private http: Http) {
    }

    getAll(page: number = 1) {
        return this.http.get('jobss?page=' + page).map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('jobss/' + _id).map((response: Response) => response.json());
    }

    create(job: Job) {
        return this.http.post('jobs', job);
    }

    update(job: Job) {
        return this.http.put('jobss/' + job.id, job);
    }

    delete(_id: string) {
        return this.http.delete('jobss/' + _id);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/job.service.ts